import React, { Component } from 'react';
import { Formio } from "react-formio";

import "formiojs/dist/formio.full.css";

const isValidJson = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};


class CustomSessionNoteFormView extends Component {

  constructor(props) {
    super(props);

    this.state = ({
      customSessionNoteJson: props.customSessionNoteJson
    })
  }

  //////////////////////////////////////
  _disabledAllField(object){
    let arrayOfObj = object.components.map(component=>{
      return {
        ...component,
        disabled: true
      }
    })
    let modifiedObj = {
      ...object,
      components:arrayOfObj
    };
    return modifiedObj;
  }
///////////////////////////////////////

  componentDidMount() {
    if (isValidJson(this.state.customSessionNoteJson)) {
      let jsonD = JSON.parse(this.state.customSessionNoteJson);
      let disabledFields = this._disabledAllField(jsonD);

      // console.log('jsonD', jsonD);

      Formio.createForm(
        document.getElementById("formio"),
        disabledFields
      ).then((form) => {
        // console.log("form created");
        form.on('change', () => {

        })
        form.on('submit', () => {

        })
      })
    }
  }


  render() {
    return (
      // <div className={formioStyles}>
      <div id="formio">
      </div>
      // </div>
    )
  }
}


export default CustomSessionNoteFormView;



// WEBPACK FOOTER //
// ./src/modules/patients/components/Encounter/CustomSessionNoteFormView.js